import { IButtonStyles } from "@fluentui/react";
import {
  concatStyleSets,
  ITheme,
  mergeStyleSets,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  commonHighContrastDisabledStyles,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineHoverFocus,
  getStandardControlSemanticColorsWithTheme,
  StandardControlSemanticColors,
} from "@1js/acui-common";

export interface TabularDescriptionClassNames {
  table: string;
  column: string;
  columnWithSeparation: string;
}

export const getAppCompoundButtonStyles = memoizeFunction(
  (theme: ITheme, customStyles?: Partial<IButtonStyles>): IButtonStyles => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    return concatStyleSets(
      {
        root: {
          minWidth: 258,
          minHeight: 84,
          width: "100%",
          padding: "12px 20px 16px 17px",
          lineHeight: "normal",
        },

        rootChecked: {
          backgroundColor:
            standardControlSemanticColors.selectedBackgroundColor,
        },

        rootCheckedHovered: [
          {
            backgroundColor: standardControlSemanticColors.hoverBackgroundColor,
          },
          commonHighContrastOutlineHoverFocus,
          commonHighContrastHoverFocusStyles,
        ],

        rootHovered: {
          backgroundColor: standardControlSemanticColors.hoverBackgroundColor,
        },

        rootFocused: {
          backgroundColor: standardControlSemanticColors.toggledBackgroundColor,
        },

        textContainer: {
          textAlign: "left",
          marginLeft: 14,
        },

        label: {
          margin: 0,
          fontWeight: "bold",
          display: "block",
        },
        labelDisabled: [
          {
            color: standardControlSemanticColors.textDisabledColor,
          },
          commonHighContrastDisabledStyles,
        ],
        descriptionDisabled: [
          {
            color: standardControlSemanticColors.textDisabledColor,
          },
          commonHighContrastDisabledStyles,
        ],
        icon: { height: 48, width: 48 },
      },
      customStyles
    );
  }
);

export const getAppCompoundButtonStylesInMenu = memoizeFunction(
  (theme: ITheme, customStyles?: Partial<IButtonStyles>): IButtonStyles => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    return concatStyleSets(
      {
        rootFocused: {
          borderColor: standardControlSemanticColors.focusedBorderColor,
          selectors: {
            ":hover": {
              borderColor: "transparent",
            },
          },
        },
      },
      customStyles
    );
  }
);

export const getTabularDescriptionClassNames = memoizeFunction(
  (): TabularDescriptionClassNames => {
    return mergeStyleSets({
      table: {
        borderCollapse: "collapse",
      },
      column: {
        paddingRight: 6,
      },
      columnWithSeparation: {
        minWidth: "2.75em",
      },
    });
  }
);
